import { EntitySimulation } from "../../entity/EntitySimulation";

export class DtoSimulationsDeleteRes extends EntitySimulation {
  public message: string | null = null;
}
